import React from 'react';
import dynamicFunction from '../utils/dynamicfunction';
import Text from './Text';
import { fontSizes } from '../constants/constants';
import ViewReverse from './ViewReverse';

const CustomTextArea = ({
  value,
  onChange,
  isFullborder = true,
  isRounded = false,
  placeholder,
  isError = false,
  className,
  label,
  divClasses,
  isRequired = false,
  errorMessage,
  isDisabled = false,
  rows = 1,
  border,
}) => {
  const { TextWeight, TextAlign } = dynamicFunction();

  return (
    <div className={`w-full ${divClasses}`}>
      <Text
        text={label && label}
        size={fontSizes.h14}
        color={isError ? 'text-red-600' : 'text-dark-grey'}
        className={'mb-1'}
        isRequired={isRequired}
      />
      <ViewReverse
        className={`px-3 py-2 ${
          border ?? (isFullborder ? 'border' : 'border-b-2')
        } ${isError ? 'border-red-600' : 'border-grey'} ${
          isRounded ? 'rounded-md' : ''
        } w-full ${className}`}
      >
        <textarea
          value={value}
          onChange={onChange}
          disabled={isDisabled}
          rows={rows}
          placeholder={placeholder}
          className={`${TextWeight.light} ${TextAlign} outline-none w-full text-sm bg-transparent`}
        />
        {errorMessage && (
          <Text
            text={errorMessage}
            color='text-red-500'
            className={'mt-2'}
            weight={TextWeight.light}
          />
        )}
      </ViewReverse>
    </div>
  );
};

export default CustomTextArea;
